import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { SLINKY } from 'HubStyleTokens/colors';
const StyledLoadingButton = styled(UILoadingButton).withConfig({
  displayName: "Button__StyledLoadingButton",
  componentId: "pshz1v-0"
})(["min-height:3rem;padding:12px 8px;line-height:20px !important;font-size:16px !important;background-color:#ff5c35 !important;border-color:#ff5c35 !important;&:hover{background-color:#ff6c49 !important;border-color:#ff6c49 !important;}", ""], props => props.disabled && `span {
    color: ${SLINKY}
  }`);
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "Button__StyledIcon",
  componentId: "pshz1v-1"
})(["line-height:20px !important;"]);

const Button = (_ref) => {
  let {
    autoFocus,
    block,
    buttonRef,
    children,
    className,
    currentStep,
    disabled,
    external,
    href,
    iconName,
    iconPosition = 'left',
    iconProps,
    onClick,
    rel,
    responsive,
    size,
    target,
    truncate,
    truncateStringProps,
    truncateTooltip,
    type,
    use
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["autoFocus", "block", "buttonRef", "children", "className", "currentStep", "disabled", "external", "href", "iconName", "iconPosition", "iconProps", "onClick", "rel", "responsive", "size", "target", "truncate", "truncateStringProps", "truncateTooltip", "type", "use"]);

  const {
    APP_DIMS
  } = useResponsiveness();
  const startAlignedIconStyle = children && iconPosition === 'left' && {
    float: 'left'
  };
  const endAlignedIconStyle = children && iconPosition === 'right' && {
    float: 'right'
  };

  const renderIcon = () => {
    if (!iconName) {
      return null;
    }

    return /*#__PURE__*/_jsx(StyledIcon, {
      name: iconName,
      size: APP_DIMS.button.iconHeight,
      style: Object.assign({
        paddingTop: 0,
        paddingBottom: 0
      }, startAlignedIconStyle, {}, endAlignedIconStyle)
    });
  };

  return /*#__PURE__*/_jsxs(StyledLoadingButton, Object.assign({
    autoFocus: autoFocus,
    block: block,
    buttonRef: buttonRef,
    className: className,
    "data-selenium": `${currentStep}_button`,
    disabled: disabled,
    external: external,
    href: href,
    iconProps: iconProps,
    rel: rel,
    responsive: responsive,
    size: size,
    style: {
      width: '100%'
    },
    target: target,
    truncate: truncate,
    truncateStringProps: truncateStringProps,
    truncateTooltip: truncateTooltip,
    type: type,
    use: use,
    onClick: onClick
  }, rest, {
    children: [renderIcon(), children]
  }));
};

export default Button;